export const decodeQueryParam = (param: string): string => {
  return decodeURIComponent(param.replace(/\+/g, ' '));
};
